import { defineNuxtPlugin } from "nuxt/app";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { useRuntimeConfig, toRaw, useRouter } from "#imports";
import { createFetch } from "ofetch";
import { generateW3CId } from "@microsoft/applicationinsights-core-js";
import { INITIAL_TRACE_KEY } from "./utils.mjs";
import { baseURL } from "#build/paths.mjs";
export default defineNuxtPlugin({
  name: "nuxt-applicationinsights:client",
  setup(nuxtApp) {
    const runtimeConfig = useRuntimeConfig();
    delete globalThis.$fetch;
    const applicationInsights = new ApplicationInsights(toRaw(runtimeConfig.public.applicationinsights));
    applicationInsights.loadAppInsights();
    applicationInsights.addTelemetryInitializer((item) => {
      if (!item.tags) {
        item.tags = [];
      }
      if (item.baseType !== "PageviewData") {
        if (item.ext?.trace) {
          item.ext.trace.traceID = generateW3CId();
          item.ext.trace.parentID = applicationInsights.context.telemetryTrace.traceID;
        }
      }
      item.tags["ai.operation.id"] = nuxtApp.payload.data[INITIAL_TRACE_KEY];
    });
    applicationInsights.context.telemetryTrace.parentID = nuxtApp.payload.data[INITIAL_TRACE_KEY]?.split("-")[1];
    globalThis.$fetch = createFetch({
      defaults: {
        baseURL: baseURL()
      }
    });
    const router = useRouter();
    router.beforeEach((to, from, next) => {
      applicationInsights.context.telemetryTrace.parentID = nuxtApp.payload.data[INITIAL_TRACE_KEY]?.split("-")[1];
      applicationInsights.context.telemetryTrace.traceID = generateW3CId();
      applicationInsights.startTrackPage(to.name);
      next();
    });
    router.afterEach((to) => {
      applicationInsights.stopTrackPage(to.name);
      applicationInsights.flush();
    });
    return {
      provide: {
        appInsights: applicationInsights
      }
    };
  }
});
